export const LIST_INVOICE_PRODUCT_TYPES_SUCCESS = 'LIST_INVOICE_PRODUCT_TYPES_SUCCESS';
export const DELETE_INVOICE_PRODUCT_TYPE_SUCCESS = 'DELETE_INVOICE_PRODUCT_TYPE_SUCCESS';
export const GET_INVOICE_PRODUCT_TYPE_SUCCESS = 'GET_INVOICE_PRODUCT_TYPE_SUCCESS';
export const CREATE_INVOICE_PRODUCT_TYPE_SUCCESS = 'CREATE_INVOICE_PRODUCT_TYPE_SUCCESS';
export const EDIT_INVOICE_PRODUCT_TYPE_SUCCESS = 'EDIT_INVOICE_PRODUCT_TYPE_SUCCESS';
export const LOAD_INVOICE_PRODUCT_TYPE_SUCCESS = 'LOAD_INVOICE_PRODUCT_TYPE_SUCCESS';
